<template>
  <div v-if="face" class="mgt-20px">
    <div class="level mgt-20px">
      <div class="level-left">
        <div class="columns is-gapless">
          <div class="column">
            <h1 class="title is-size-3">
              {{$t('detailFace.title', { code: face.code }) }}
              <b-tag v-if="!face.actif"
                     type="has-background-subMenu"
                     class="has-text-white mgl-5px">
                {{$t('detailFace.faceArchive')}}
              </b-tag>
            </h1>
            <app-breadcrumb :breadcrumb="breadcrumb"/>
          </div>
        </div>
      </div>
      <a ref="lienDownload"></a>
      <div class="level-right">
        <div class="buttons">
          <dropdownButton
            type="is-addOrEdit"
            class="mgr-2"
            :permission="constantes.EMPLACEMENT.maj"
            :actions="actionSecondary"
            @click="goToModif">
              {{ $t('detailFace.actions.edit') }}
          </dropdownButton>
          <button class="button">
            <b-dropdown position="is-bottom-left" classs="has-text-left">
              <div slot="trigger">
                <b-icon icon="file-download" type="is-default"></b-icon>
                <b-icon icon="chevron-down"
                        class="has-text-secondary-icon">
                </b-icon>
              </div>
              <b-dropdown-item
                class="has-text-left"
                @click="checkPermissions(constantes.EMPLACEMENT.editer) ?
                edition(constantes.TYPE_PDF) : showPopUp()">
                {{ $t('general.popUpEdition.type.pdf') }}
              </b-dropdown-item>
              <b-dropdown-item
                @click="checkPermissions(constantes.EMPLACEMENT.editer) ?
                edition(constantes.TYPE_DOCX) : showPopUp()">
                {{ $t('general.popUpEdition.type.docx') }}
              </b-dropdown-item>
            </b-dropdown>
          </button>
          <piece-jointe-button
            class="mgr-2"
            :perm="constantes.EMPLACEMENT.maj"
            autoSave>
          </piece-jointe-button>
          <button class="button">
            <b-dropdown position="is-bottom-left" class="has-text-left">
              <div slot="trigger">
                <b-icon icon="call-split" type="is-default"></b-icon>
                <b-icon icon="chevron-down" class="has-text-secondary-icon"></b-icon>
              </div>
              <p class="has-text-icon-more is-size-7 mgl-15px mgt-10px">
                {{$t('detailFace.titleAccesRapide') }}
              </p>
            <b-dropdown-item has-link>
              <router-link-blank
                :to="{ name: 'c.bodac.catalogue-face',
                params: {
                        id:face.produitId,
                      }
                    }"
                :message="$t('detailFace.seeProduct')"
                classMessage="has-text-default is-size-6"
                classComposant="noTextDecoration"
              />
            </b-dropdown-item>
            <b-dropdown-item
              :has-link="!!tourneeAffichageId"
              :disabled="tourneeAffichageId === null">
              <router-link-blank v-if="tourneeAffichageId"
                :to="{ name: 'c.logistique.tournee_modele',
                params: {id: tourneeAffichageId}}"
                :message="$t('detailFace.voirListeAffichage')"
                classMessage="has-text-default is-size-6"
                classComposant="noTextDecoration"
              />
              <span v-else class="is-size-6">{{$t('detailFace.voirListeAffichage')}}</span>
            </b-dropdown-item>
            <b-dropdown-item :has-link="!!face.materiel.id">
              <router-link-blank v-if="face.materiel.id"
                :to="{ name: 'l.baux.contrat-by-materiel',
                params: {typePatrimoine: constantes.MATERIEL, patrimoineId: face.materiel.id}}"
                :message="$t('materiel.contrat')"
                classMessage="has-text-default is-size-6"
                classComposant="noTextDecoration"
              />
              <span v-else class="is-size-6">{{$t('materiel.contrat')}}</span>
            </b-dropdown-item>
          </b-dropdown>
        </button>
        </div>
      </div>
    </div>
    <error-msg-component :messages="messages"
                         class="mgt-20px"
                         :error="error"
                         :messagesChampsVide="messagesChampsVide"
                         :champsVide="champsVide"
                         :title="titleError"
                         :withEmplyFields="true"
                         @close="error = $event"
    />
    <informations-generation-code-face v-if="face.materiel"
                                       :materiel="face.materiel"
                                       :dispositif="face.materiel.dispositif"
                                       :tree-link="true"
    />
    <div class="tab mgh-0">
      <ul>
        <li :class="{'is-active': activeTab === 'InfoGenerale'}"
            @click="activeTab = 'InfoGenerale'">
          {{ $t('detailFace.tab.infoGenerale') }}
        </li>
        <li :class="{'is-active': activeTab === 'ListeOtTechnique'}"
            v-if="afficherLogistique"
            @click="activeTab = 'ListeOtTechnique'">
          {{ $t('detailFace.tab.listeOt') }}
        </li>
        <li :class="{'is-active': activeTab === 'listeEtatHistorique'}"
          @click="activeTab = 'listeEtatHistorique'">
          {{ $t('patrimoine.patrimoineEtatHistorique.title') }}
        </li>
        <li :class="{'is-active': activeTab === 'InfoDivers'}"
            @click="activeTab = 'InfoDivers'">
          {{ $t('adresseEmplacement.divers') }}
        </li>
      </ul>
    </div>
    <component :is="activeTab"
                :face="face"
                :idPatrimoine="face.id"
                :ids="[face.id]"
                :typePatrimoine="constantes.FACE"
                :showPerPage="true"
                :data="face"
                :isPatrimoine="true">
    </component>
    <b-modal v-model="openPopUpPrevention"
             has-modal-card
             class="modal">
      <pop-up-prevention
        v-if="face"
        @no="openPopUpPrevention = false;"
        @yes="actionPopUpPrevention"
        :messagesPopup="messagesErreurPopUp"
        :isErrorPopup.sync="errorPopUp"
        :cancel="$t('general.non')"
        :validate="$t('general.oui')"
        :mess-header="messageHeader">
      </pop-up-prevention>
    </b-modal>
  </div>
</template>

<script>

import routerLinkBlank from '@/components/general/routerLinkBlank';
import dropdownButton from '@/components/general/button/dropdownButton';
import { createNamespacedHelpers } from 'vuex';
import { EMPLACEMENT } from '@/configuration/gabed/permissionsGabedConf';
import {
  get, deleteFace, checkUtilisationFaceAsync, archiver,
} from '@/api/gabed/face';
import messageErreur from '@/services/general/messageErreur';
import errorMsgComponent from '@/components/general/errorMsgComponent';
import validationDeleteFace from '@/services/gabed/face/validationDeleteFace';
import messageSucces from '@/services/general/messageSucces';
import validationGeneral from '@/services/validation/validation';
import popUpPrevention from '@/components/general/popUpPrevention';
import validationFace from '@/services/gabed/face/validationFace';
import getAll from '@/api/logistique/tourneeLigne';
import InfoDivers from '@/components/gabed/face/infoDivers';
import InfoGenerale from '@/components/gabed/face/infoGenerale';
import ListeOtTechnique from '@/components/emplacementTechnique/listeOtTechnique';
import { PARAMETRES_INTERNE_KEYS } from '@/store/modules/parametres-mutation-type';
import {
  FACE,
  ACTION_TYPE_ARCHIVAGE_DESARCHIVAGE, ACTION_TYPE_SUPPRESSION, MATERIEL,
} from '@/configuration/gabed/emplacement/emplacementConf';
import { TYPE_DOCX, TYPE_PDF } from '@/configuration/edition/editionConf';
import edition from '@/api/edition';
import { TYPE_EDITION_FACE, TYPE_EDITION_FACE_PATRIMOINE } from '@/configuration/catalogue/produitConf';
import InformationCreateUpdateUser from '@/components/general/informationCreateUpdateUser';
import pieceJointeButton from '@/components/general/button/pieceJointeButton';
import breadcrumb from '@/components/general/breadcrumb';
import informationsGenerationCodeFace from '@/components/gabed/face/informationsGenerationCodeFace';
import listeEtatHistorique from '@/components/patrimoineEtatHistorique/l_patrimoineEtatHistorique';

const Permissions = createNamespacedHelpers('permissions');
const Attachments = createNamespacedHelpers('attachments');
const Face = createNamespacedHelpers('face');
const Societe = createNamespacedHelpers('societe');
const Parametres = createNamespacedHelpers('parametres');

export default {
  name: 'c_face',
  data() {
    return {
      face: null,
      activeTab: 'InfoGenerale',
      constantes: {
        EMPLACEMENT,
        FACE,
        TYPE_PDF,
        TYPE_DOCX,
        ACTION_TYPE_ARCHIVAGE_DESARCHIVAGE,
        ACTION_TYPE_SUPPRESSION,
        MATERIEL,
      },
      messages: [],
      champsVide: [],
      messagesChampsVide: [],
      error: false,
      titleError: null,
      openPopUpPrevention: false,
      actionTypePopUpPrevention: null,
      errorPopUp: false,
      messagesErreurPopUp: [],
      tourneeAffichageId: null,
    };
  },
  components: {
    appBreadcrumb: breadcrumb,
    InfoDivers,
    InfoGenerale,
    dropdownButton,
    routerLinkBlank,
    errorMsgComponent,
    popUpPrevention,
    ListeOtTechnique,
    InformationCreateUpdateUser,
    pieceJointeButton,
    informationsGenerationCodeFace,
    listeEtatHistorique,
  },
  computed: {
    ...Permissions.mapGetters({
      checkPermissions: 'checkPermissions',
    }),
    ...Parametres.mapGetters({
      parametresInterne: 'parametresInterne',
    }),
    ...Societe.mapGetters({
      societeActiveId: 'societeActiveId',
    }),
    afficherLogistique() {
      return this.parametresInterne(PARAMETRES_INTERNE_KEYS.afficherLogistiqueTechnique.key);
    },
    breadcrumb() {
      return [
        { title: this.$i18n.t('listeClients.racine'), route: this.$PAGE_DEFAULT, isActive: false },
        { title: this.$i18n.t('emplacement.title'), route: { name: 'l.gabed.emplacement' }, isActive: false },
        {
          title: this.$i18n.t('detailEmplacement.titleWithoutN'),
          route: { name: 'c.gabed.emplacement-detailEmplacement', params: { id: this.face.materiel.dispositif.emplacementId } },
          isActive: false,
        },
        { title: this.$i18n.t('detailFace.detailWithoutCode'), route: '', isActive: true },
      ];
    },
    disableDesarchiver() {
      return !this.face.actif && !this.face.materiel.actif;
    },
    messageHeader() {
      switch (this.actionTypePopUpPrevention) {
        case ACTION_TYPE_ARCHIVAGE_DESARCHIVAGE:
          return this.$t(('detailFace.archivageDesarchiver.' + (this.face.actif ? 'archivage' : 'desarchivage')));
        case ACTION_TYPE_SUPPRESSION:
          return this.$t('detailFace.supprimerFace', { code: this.face.code });
        default:
          return '';
      }
    },
    actionSecondary() {
      const actions = [
        {
          label: this.$t('general.button.' + (this.face.actif ? 'archiver' : 'desarchiver')),
          action: () => { this.showPopUpPrevention(ACTION_TYPE_ARCHIVAGE_DESARCHIVAGE); },
          permissionAction: EMPLACEMENT.supprimer,
          disabled: this.disableDesarchiver,
          order: 2,
        },
        {
          label: this.$t('general.button.delete'),
          action: () => { this.showPopUpPrevention(ACTION_TYPE_SUPPRESSION); },
          permissionAction: EMPLACEMENT.supprimer,
          order: 3,
        },
      ];
      if (this.face.actif) {
        actions.push(
          {
            label: this.$t('detailFace.actions.remplacer'),
            action: () => { this.checkUpdateProduitFace(); },
            permissionAction: EMPLACEMENT.maj,
            order: 1,
          },
        );
      }
      return actions;
    },
  },
  methods: {
    ...Attachments.mapActions({
      setAttachmentContext: 'setContext',
      setAttachmentElementId: 'setElementId',
    }),
    ...Parametres.mapActions({
      loadParametresInterne: 'loadParametresInterne',
    }),
    ...Permissions.mapActions({
      showPopUp: 'showPopup',
    }),
    ...Face.mapActions({
      setInfoFace: 'setInfoFace',
    }),
    showPopUpPrevention(actionType) {
      this.errorPopUp = false;
      this.messagesErreurPopUp = [];
      this.actionTypePopUpPrevention = actionType;
      this.openPopUpPrevention = true;
    },
    async actionPopUpPrevention() {
      switch (this.actionTypePopUpPrevention) {
        case ACTION_TYPE_ARCHIVAGE_DESARCHIVAGE:
          await this.archiverFace();
          break;
        case ACTION_TYPE_SUPPRESSION:
          await this.deleteFace();
          break;
        default:
          break;
      }
    },
    closePopUpPrevention() {
      this.openPopUpPrevention = false;
      this.actionTypePopUpPrevention = null;
      this.errorPopUp = false;
      this.messagesErreurPopUp = [];
    },
    async archiverFace() {
      const loadingComponent = this.$buefy.loading.open();
      this.errorPopUp = false;
      this.messagesErreurPopUp = [];
      try {
        const faceArchive = (await archiver(this.face.id, this.face.actif)).data.result;
        this.closePopUpPrevention();
        messageSucces(this.$i18n.t('listeFace.messages.success.' + (this.face.actif ? 'archivage' : 'desarchivage')));
        this.face.actif = faceArchive.actif;
        loadingComponent.close();
      } catch (e) {
        if (e.response?.data?.error) {
          validationFace(e.response, this.messagesErreurPopUp);
          this.errorPopUp = true;
        } else messageErreur(this.$i18n);
        loadingComponent.close();
        throw e;
      }
    },
    async checkUpdateProduitFace() {
      this.champsVide = [];
      this.messagesChampsVide = [];
      this.messages = [];
      this.error = false;
      this.titleError = null;
      const loadingComponent = this.$buefy.loading.open();
      try {
        await checkUtilisationFaceAsync(this.face.id);
        this.setInfoFace({
          id: this.face.id,
          code: this.face.code,
          societeId: this.face.materiel.dispositif.emplacement.societeId,
          agenceId: this.face.materiel.dispositif.emplacement.agenceId,
          idEmplacement: this.face.materiel.dispositif.emplacementId,
        });
        loadingComponent.close();
        await this.$router.push({ name: 'm.gabed.emplacement-remplacementProduitFace' });
      } catch (e) {
        if (e.response && e.response.data.error) {
          validationGeneral(this.$i18n, e.response, this.champsVide,
            this.messages, this.messagesChampsVide);
          validationDeleteFace(e.response, this.messages);
          this.titleError = 'detailFace.error.remlacementImpossible';
          this.error = true;
          loadingComponent.close();
          return;
        }
        messageErreur(this.$i18n);
        loadingComponent.close();
        throw (e);
      }
    },
    async deleteFace() {
      const loadingComponent = this.$buefy.loading.open();
      this.errorPopUp = false;
      this.messagesErreurPopUp = [];
      try {
        await deleteFace(this.face.id);
        this.closePopUpPrevention();
        messageSucces(this.$i18n.t('listeFace.messages.success.faceDeleted', { code: this.face.code }));
        await this.$router.push({
          name: 'c.gabed.emplacement-detailEmplacement',
          params: { id: this.face.materiel.dispositif.emplacementId },
        });
        loadingComponent.close();
      } catch (e) {
        if (e.response?.data?.error) {
          validationDeleteFace(e.response, this.messagesErreurPopUp);
          this.errorPopUp = true;
        } else messageErreur(this.$i18n);
        loadingComponent.close();
        throw (e);
      }
    },
    goToModif() {
      this.$router.push({
        name: 'm.gabed.emplacement-faceEdition',
        params: { idMateriel: this.face.materiel.id, idFace: this.face.id },
      });
    },
    async getTourneeAffichageId() {
      const param = {
        query: {
          faceIds: [this.$route.params.idFace],
          societeId: this.societeActiveId,
        },
        skipCount: 0,
        MaxResultCount: 20,
      };
      const response = (await getAll(param)).data.result.items;
      if (response.length) this.tourneeAffichageId = response[0].tournee.id;
    },
    async edition(format) {
      const loadingComponent = this.$buefy.loading.open();
      try {
        const response = await edition({
          ids: [this.face.produitId],
          extension: format,
          typeDonnee: TYPE_EDITION_FACE,
          typeEdition: TYPE_EDITION_FACE_PATRIMOINE,
        });
        const link = this.$refs.lienDownload;
        link.href = window.URL.createObjectURL(response.data);
        const disposition = response.request.getResponseHeader('Content-Disposition');
        link.download = decodeURI(disposition.match(/filename\*=UTF-8''(.*?)$/)[1]);
        link.click();
        loadingComponent.close();
      } catch (e) {
        loadingComponent.close();
        messageErreur(this.$i18n);
        throw e;
      }
    },
  },
  async mounted() {
    const loadingComponent = this.$buefy.loading.open();
    try {
      await this.setAttachmentContext({ module: 'Materiel' });
      await this.loadParametresInterne([PARAMETRES_INTERNE_KEYS.afficherLogistiqueTechnique.key]);
      this.face = (await get(this.$route.params.idFace)).data.result;
      await this.getTourneeAffichageId();
      await this.setAttachmentElementId({ id: this.face.materiel.id });
      this.setInformationPage(this.$t('pageGeneral.detail', { item: this.face.code }));
      loadingComponent.close();
    } catch (e) {
      messageErreur(this.$i18n);
      loadingComponent.close();
      throw e;
    }
  },
};
</script>
